export enum PurchaseOrderStatus {
  Open = 'open',
  Closed = 'closed',
  Draft = 'draft',
  Cancelled = 'cancelled',
  Voided = 'voided',
}
